import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./header";
import Footer from "./footer";
import HomeScreen from "./homeView";
import "../App.css"

function Home() {

    return (
        <div className="App" style={{ paddingHorizontal: 25 }}>
            <div>
                <Header />
                <HomeScreen />
                <Footer />
            </div>
        </div>
    );
}

export default Home;
